import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FilterSelectItem from '../../../../molecules/FilterSelectItem';
export function SingleSelect({ name, filters, setFilter, options, translateLabels, defaultValue, }) {
    const { t } = useTranslation();
    const optionsMemoized = useMemo(() => {
        //
        // If it looks like an array `any[]`
        // ["open","gesloten",null,{key,value}]
        //
        if (Array.isArray(options)) {
            //
            // If it looks like an array of strings `string[]`
            // // ["open","gesloten",null]
            //
            if (options.some(v => typeof v === 'string')) {
                return options.map(value => ({
                    value: `${value}`,
                    label: translateLabels
                        ? t(`dossier.filters.${name}.values.${value}`)
                        : `${value}`,
                }));
            }
        }
        throw new Error(`Can not determine option type`);
    }, [t, name, filters, setFilter, options, translateLabels]);
    return (_jsx(FilterSelectItem, { name: name, label: t(`dossier.filters.${name}.label`), placeholder: t(`dossier.filters.${name}.placeholder`), value: filters[name] || '', setFilter: setFilter(name), options: optionsMemoized, defaultValue: defaultValue || undefined }));
}
